<template>
  <section id="hero" class="hero">
    <img :src="cover" :alt="title" class="cover" />
    <div class="content">
      <h1 class="title">
        {{ title }}
      </h1>
      <h2 class="subtitle">
        {{ subtitle }}
      </h2>
    </div>
  </section>
</template>

<script>
export default {
  name: "Hero",
  props: {
    title: String,
    subtitle: String,
    cover: String,
  },
}
</script>

<style scoped lang="scss">
.hero {
  color: #fff;
  text-align: center;
  background-color: #000;
  min-height: 15rem;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
}

.content {
  position: relative;
  z-index: 1;
}

.title {
  font-size: 3rem;
  font-weight: bolder;
  text-align: center;
  margin: 0 0 0.5rem;
  @media (max-width: 800px) {
    font-size: 1.15rem;
  }
}

.subtitle {
  font-size: 1.15rem;
  font-weight: normal;
  color: rgba(#fff, 0.5);
  @media (max-width: 800px) {
    font-size: 1rem;
  }
}

.cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0.25;
}
</style>
